import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { AxiosError } from 'axios';
import { authApiClient } from '../../../utils/axios';
import { showSnackbar } from '../../../api/snackbarSlice';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';
export const createUser = async ({ name, email, role_ids = [] }) => {
  const { data } = await authApiClient.post('/users', { name, email, role_ids });
  return data;
};

export const useCreateUserHandler = ({ onSuccess } = {}) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const { settings } = useTranslatedMessages();
  const teamSnacks = settings.team?.snackbar ?? {};

  const mutation = useMutation({
    mutationFn: createUser,
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['auth-users'] });
      dispatch(
        showSnackbar({
          message: data?.message || teamSnacks.invite_success || 'User invited successfully',
          severity: 'success',
        }),
      );
      onSuccess?.(data);
    },
    onError: (error) => {
      const message =
        error instanceof AxiosError
          ? error.response?.data?.errors?.message || error.message
          : teamSnacks.invite_error || 'Failed to invite user';
      dispatch(showSnackbar({ message, severity: 'error' }));
    },
  });

  return {
    mutate: mutation.mutate,
    isPending: mutation.isPending,
  };
};
